<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer008">
<p class="pl-center"><em class="italic">To my parents.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?ed6e191a